import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBellSolid = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M14.625 5.625v4.625a1 1 0 0 0 1 1h.25a1 1 0 0 1 1 1v.25a1 1 0 0 1-1 1H2.125a1 1 0 0 1-1-1v-.25a1 1 0 0 1 1-1h.25a1 1 0 0 0 1-1V5.625a5.625 5.625 0 0 1 11.25 0M9 18a2.25 2.25 0 0 1-2.032-1.282c-.238-.499.23-.968.782-.968h2.5c.552 0 1.02.47.782.968A2.25 2.25 0 0 1 9 18"
	})
});
export default SvgBellSolid;
